import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import arrows from "../../../src/assets/images/mo_icon/mo_arrow_left.svg";


import { withTranslation } from "react-i18next";
import {
  makeAjax,
  respStatus,
  showMessage,
  url,
} from "../../helpers/global_helper";
import { Link } from "react-router-dom";
import { iconData } from "../../components/Layout/SideBarMenu";
import PromoIcon from "../../assets/images/mo_icon/promo.svg";
import NewIcon from "../../assets/images/mo_icon/new.svg";
import HotTagIcon from "../../assets/images/mo_icon/hot.svg";
const gameCodesSequence = [
  // "AllGames",
  "WH",
  "48D",
  "36D",
  "24D",
  "12D",
  "SB",
  "DT",
  "PD",
  // "MB",
];

const AllMoGames = (props) => {
  const Navigate = useNavigate();
  const [gameData, setGameData] = useState([]);


  const fetchGameList = () => {
    makeAjax(url.DINGDONG_API.listGame).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        showMessage(response);
        return;
      }
      let tempGameList = response.data.map(game => ({
        ...game,
        label_lobby: game.label_lobby.split(","),
        is_new: game.label_lobby.includes("new"),
        is_promo: game.label_lobby.includes("promo"),
        is_hot: game.label_lobby.includes("hot")
      }));
      let gameList = [];
      gameList.push({
        game_code: 'AllGames',
        label_lobby: [],
        is_new: false,
        is_promo: false,
        is_hot: false
      });
      gameList = [...gameList, ...tempGameList];
      gameList.push({
        game_code: 'MB',
        label_lobby: [],
        is_new: false,
        is_promo: false,
        is_hot: false
      });

      setGameData(gameList);
    });
  };

  useEffect(() => {
    fetchGameList();
  }, []);

  return (
    <div className="mo_allgames">
      <div className="mo_pages_topbar">
        <div className="back_arrow" onClick={() => Navigate("/")}>
          <img src={arrows}></img>
        </div>
        <div className="mo_page_heading">
          <h2>{props.t('allgame', { defaultValues: "All Games" })}</h2>
        </div>
      </div>
      <div className="allgame_icon">
        {gameCodesSequence.map((gameCode, index) => {
          const item = gameData.find((game) => game.game_code === gameCode);
          if (!item) return null;
          return (
            <Link to={`/game/${item.game_code}`}>
              <React.Fragment>
                <div className="allgame_item" key={index}>
                  <span className="hot-promo">
                    {item.is_promo && <img className="blink_img" src={PromoIcon} alt="" />}
                    {item.is_new && <img className="blink_img" src={NewIcon} alt="" />}
                    {item.is_hot && <img className="blink_img" src={HotTagIcon} alt="" />}

                  </span>
                  <img
                    src={iconData[item.game_code]}
                    alt={item.game_code}
                  >

                  </img>

                  {/* <h4>{props.t(item.game_code + "_label")}</h4> */}
                  <h4>{props.t(item.game_code + "_label", { defaultValue: item.game_name.replace("Dingdong ", "") })}</h4>

                </div>
              </React.Fragment>
            </Link>
          );
        })}


      </div>
    </div>
  );
};

export default withTranslation()(AllMoGames);
